// Copyright (c) 2023 Deere & Company

import {
    addFile,
    resetDuplicatePinPlate,
    updateAddressLine1,
    updateAddressLine2,
    updateCity,
    updateCountry,
    updateDealerLocation,
    updateDuplicatePinPlate,
    updateInstructions,
    updateMachineModel,
    updateMailingRecipient,
    updateMissingPlateReason,
    updatePIN,
    updatePhone,
    updateRequesterTSCM,
    updateState,
    updateZipCode
} from './duplicate-pin-plate';
import {
    handleDuplicatePinPlateInProcess,
    handleDuplicatePinPlateUpdate
} from './handle-update';
import {
    readProductDetails,
    resetProductDetails
} from './validate-pin';
import {
    resetFormValidation,
    updateFormValidation
} from './form-validation';
import {deleteFile} from './delete-file';
import {handleDuplicatePinPlateSubmit} from './handle-submit';

import {readPinPlateRequest} from './get-duplicate-pin-plate-request';
import sharedActionCreators from '../../shared/action-creators';
import {updateTemporaryObjectKey} from './update-temporary-object-key';

export default {
    ...sharedActionCreators,
    addFile,
    deleteFile,
    handleDuplicatePinPlateInProcess,
    handleDuplicatePinPlateSubmit,
    handleDuplicatePinPlateUpdate,
    readPinPlateRequest,
    readProductDetails,
    resetDuplicatePinPlate,
    resetFormValidation,
    resetProductDetails,
    updateAddressLine1,
    updateAddressLine2,
    updateCity,
    updateCountry,
    updateDealerLocation,
    updateDuplicatePinPlate,
    updateFormValidation,
    updateInstructions,
    updateMachineModel,
    updateMailingRecipient,
    updateMissingPlateReason,
    updatePIN,
    updatePhone,
    updateRequesterTSCM,
    updateState,
    updateTemporaryObjectKey,
    updateZipCode
};



// WEBPACK FOOTER //
// ./src/product/duplicate-pin-plate/action-creators/index.js